import { Box } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import type { DashboardSection } from '../../../types';

export const CalloutSection = ({ section }: { section: DashboardSection }) => (
  <Box bg="secondary-50" borderRadius="8px" p="10px">
    <Text variant="p">{section.text}</Text>
  </Box>
);
